import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'smartControl_mng',
  components: {
    smartControlTable: function smartControlTable() {
      return import('./smartControl_page');
    },
    smartControlItemTable: function smartControlItemTable() {
      return import('./smartControlItem_page');
    },
    smartControlCmdTable: function smartControlCmdTable() {
      return import('./smartControlCmd_page');
    },
    smartControlLogTable: function smartControlLogTable() {
      return import('./smartControlLog_page');
    },
    smartControlTLogTable: function smartControlTLogTable() {
      return import('./smartControlTLog_page');
    },
    smartControlTLogAnalysis: function smartControlTLogAnalysis() {
      return import('./smartControl_analysis');
    },
    smartControlRuleTable: function smartControlRuleTable() {
      return import('./smartControlRule_page');
    },
    smartControlWarnLogTable: function smartControlWarnLogTable() {
      return import('./smartControlWarnLog_page');
    },
    smartControlTaskTable: function smartControlTaskTable() {
      return import('./smartControlTask_page');
    }
  },
  data: function data() {
    return {
      tableShow: 'smartControl',
      current: {}
    };
  },
  methods: {
    gosmartControl: function gosmartControl() {
      this.tableShow = 'smartControl';
    },
    goChild: function goChild(data, tableName) {
      this.current = data;
      this.tableShow = tableName;
    }
  }
};